import React, { useEffect, useState } from 'react'
import { Auth } from '@aws-amplify/auth'
import Router from 'next/router'
import { useSelector } from 'react-redux'
import { userSelector } from '@enlyt/stores/Auth/Selectors'
import { parseJwt } from 'helpers/fhir/resourceSelect'

const withAuth = Component => {
  const Wrapper = props => {
    const [isLoading, setIsLoading] = useState(true)
    const user = useSelector(userSelector)

    useEffect(() => {
      const isTokenExpired = token => {
        if (token) {
          const jwtToken = parseJwt(token)
          return jwtToken.exp < new Date() / 1000
        }
        return false
      }
      const checkIsAuthenticated = async () => {
        try {
          const session = await Auth.currentSession()

          if (session && session.isValid()) {
            setIsLoading(false)
          } else {
            console.warning('invalid session')
          }
        } catch {
          if (user && user?.idToken && !isTokenExpired(user?.idToken)) {
            setIsLoading(false)
          } else {
            Router.push('/auth/sign-in')
          }
        }
      }

      checkIsAuthenticated()
    }, [user])
    return !isLoading && <Component {...props} />
  }

  Wrapper.getInitialProps = async ctx => {
    const componentProps =
      Component.getInitialProps && (await Component.getInitialProps(ctx))
    return { ...componentProps }
  }
  return Wrapper
}

export default withAuth
